module.exports = (__webpack_require__(1))(190);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/EditAssetstoreWidget.js from dll-reference girder_lib
// module id = 26
// module chunks = 0